import { TELEMETRY_EVENT_NAMES } from '@src/telemetry/telemetry-events.constants'
import { trackEvent } from '@src/telemetry/track'
import { IProductCard } from '../product-card.types'
export const productSwiperScrollEventTrigger = (product: IProductCard) => {
  const productCard = product.product
  return () =>
    trackEvent(TELEMETRY_EVENT_NAMES.PRODUCT_CARD_SCROLLED, {
      name: productCard.title,
      department: productCard?.classification?.department,
      division: productCard?.classification?.division,
      subdepartment: productCard?.classification?.subdepartment,
      product_id: productCard?.productId,
    })
}
